import { render, staticRenderFns } from "./FFLogo.vue?vue&type=template&id=690e8996&"
import script from "./FFLogo.vue?vue&type=script&lang=js&"
export * from "./FFLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports